import { useEffect, useRef, useCallback, useState } from "react";

export function useScroll<T extends HTMLElement>(storageKey: string) {
  const ref = useRef<T | null>(null);
  const scrollPosition = useRef({ x: 0, y: 0 });
  const [scrolledNode, setScrolledNode] = useState<T | null>(null); // Track which node is scrolling

  useEffect(() => {
    const handleScroll = (event: Event) => {
      const target = event.target as HTMLElement;
      console.log("Scroll position:", target.scrollTop, target.scrollLeft);
    };

    const element = ref.current;
    if (element) {
      element.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (element) {
        element.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return { ref, scrolledNode };
}
